module.exports = __webpack_public_path__ + "img/female-newborn-foot.3e66182a.svg";